import PropTypes from 'prop-types';

var Variants;
(function (Variants) {
    Variants["DEFAULT"] = "default";
    Variants["ROUNDED"] = "rounded";
    Variants["UNDERLINE"] = "underline";
})(Variants || (Variants = {}));
var propTypes = {
    variant: PropTypes.oneOf([
        Variants.DEFAULT,
        Variants.ROUNDED,
        Variants.UNDERLINE,
    ]),
    name: PropTypes.string,
    label: PropTypes.string,
    isValid: PropTypes.bool,
    errorMessage: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    primaryConditionClassName: PropTypes.string,
    secondaryConditionClassName: PropTypes.string,
    alignRight: PropTypes.bool,
    clearable: PropTypes.bool,
    rounded: PropTypes.bool,
    type: PropTypes.oneOf(['text', 'number', 'tel', 'password', 'search']),
    icon: PropTypes.node,
    withIconClassName: PropTypes.string,
    iconClassName: PropTypes.string,
    primaryCondition: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    secondaryCondition: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    testId: PropTypes.string,
    'data-testid': PropTypes.string,
    hideLabel: PropTypes.bool,
    relativelyStyledConditions: PropTypes.bool,
    isMultilineSecondaryCondition: PropTypes.bool,
    inputRef: PropTypes.oneOfType([
        PropTypes.shape({ current: PropTypes.instanceOf(HTMLInputElement) }),
        PropTypes.func,
    ]),
    showStepperArrows: PropTypes.bool,
};
var defaultProps = {
    variant: Variants.DEFAULT,
    clearable: true,
    alignRight: false,
    rounded: false,
    icon: null,
    disabled: false,
    placeholder: '',
    hideLabel: false,
    relativelyStyledConditions: false,
    type: 'text',
    name: 'input',
    showStepperArrows: true,
};

export { Variants, defaultProps, propTypes };
